import React, { Component, PropTypes } from 'react';
import * as Icons from 'components/Icons';
import { pageModules } from 'Constants';
import { Units, hexToRgba, Colors } from 'Css';

const css = oxygenCss({
  column: {
    position: 'relative',
    textAlign: 'center',
    boxSizing: 'border-box',
    margin: Units.base / 2,
    flex: 1,
    backgroundColor: '#F0F0F0',
    height: Units.keyline * 2.5,
    cursor: 'pointer',
    padding: `${Units.keyline / 2}px 0`,
    ':hover': {
      backgroundColor: `${hexToRgba(Colors.creen, 10)}`
    }
  },
  header: {
    lineHeight: `24px`,
    fontSize: 16,
    fontWeight: 400,
    textAlign: 'center',
    letterSpacing: '0.3px'
  }
});

const styles = {
  icon: {
    width: Units.base * 6,
    height: Units.base * 6
  }
};

class PageModuleMenuIcon extends Component {
  static propTypes = {
    type: PropTypes.string,
    addPageModule: PropTypes.func
  };

  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  render() {
    const { type, addPageModule } = this.props;
    const { getIntlMessage } = this.context;
    let Icon;
    if(type === 'quiz'){
      Icon = Icons[pageModules['task'].icon];
    } else {
      Icon = Icons[pageModules[type].icon];
    }

    return (
      <div className={css.column} onTouchTap={() => addPageModule(type)}>
        <Icon color={'#777777'} style={styles.icon} />
        <div className={css.header}>{getIntlMessage(`pageModule.${type}`)}</div>
      </div>
    );
  }
}

export default PageModuleMenuIcon;



// WEBPACK FOOTER //
// ./src/js/components/Page/ModuleMenu/PageModuleMenuIcon.js